<template>
    <div class="super-admin-chat">
        <div class="select-chat-users">
            <v-select class="v-select-item" outlined dense :no-data-text="$t('no_data')" item-text="title" item-value="role" :items="roles" v-model="selectedTab"
                      @change="showUsers"/>
            <v-select class="v-select-item" outlined dense :no-data-text="$t('no_data')" item-text="classTitle" item-value="id" :items="classes"
                      v-model="selectedClassId" @change="showUsersByClass" v-if="selectedTab !== 'teacher' && selectedTab !== 'group'"/>
        </div>
        <Chat ref="chat"/>
    </div>
</template>

<script>
import Chat from '@/components/chat/Chat.vue'
import SchoolClassService from '@/_services/school-class.service'

export default {
  name: 'DirectorChat',
  components: { Chat },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    }
  },
  data () {
    return {
      roles: [
        { role: 'teacher', title: this.$t('teachers') },
        { role: 'student', title: this.$t('students') },
        { role: 'parent', title: this.$t('parents') },
        { role: 'group', title: 'Группы' }
      ],
      classes: [],
      selectedTab: '',
      selectedClassId: ''
    }
  },
  mounted () {
    this.getSchoolClasses()
    this.showUsers('teacher')
    this.roles = [
      { role: 'teacher', title: this.$t('teachers') },
      { role: 'student', title: this.$t('students') },
      { role: 'parent', title: this.$t('parents') },
      { role: 'group', title: 'Группы' }
    ]
  },
  methods: {
    showUsers (role) {
      this.selectedTab = role
      this.selectedClassId = ''
      this.$refs.chat.selectedRole = role
      this.$refs.chat.recipientUserId = ''
      this.$refs.chat.users = []
      this.$refs.chat.messages = []
      this.$refs.chat.allReserveUsers = []
      if (role === 'teacher' || role === 'group') {
        this.$refs.chat.fetchUsers(this.selectedTab)
      }
    },

    showUsersByClass (classId) {
      this.$refs.chat.fetchUsers(this.selectedTab, classId)
    },

    getSchoolClasses () {
      SchoolClassService.getAllBySchool(this.school.id).then((res) => {
        this.classes = res.map((klass) => {
          klass.classTitle = klass.classLevel + klass.classLabel
          return klass
        })
      }).catch((err) => {
        this.$toast.error(err)
      })
    }
  }
}
</script>

<style scoped>

</style>
